module.exports = __webpack_public_path__ + "img/illustration-categories-2-mobile.acb34a27.gif";